import useInterval from '@restart/hooks/useInterval';
import axios from 'axios';
import classNames from 'classnames/bind';
import React, { useState } from 'react';

import styles from './LiveView.module.scss';

import ViewFinder from '@/components/ui/ViewFinder';

const cx = classNames.bind(styles);

const Window = ({ robot, sn }) => {
  const [isLoading, setLoading] = useState(true);
  const [videoUrl, setVideoUrl] = useState();

  useInterval(() => load(), 1000, videoUrl);

  const load = () => {
    if (!robot.metadata['VIDEO_TYPE']) {
      setVideoUrl(null);
      return;
    }

    const body = { type: robot.metadata['VIDEO_TYPE'] };

    setLoading(true);
    axios.post(`${process.env.REACT_APP_STREAMHUB_URL}/robots/${robot.id}`, body).then((result) => {
      const { success, data } = result.data;

      if (success) {
        const nextVideoUrl = data.urls.find((url) => new URL(url).searchParams.get('deviceId') === sn);
        setVideoUrl(nextVideoUrl);
      } else {
        setVideoUrl(null);
      }
      setTimeout(() => setLoading(false), 1000);
    });
  };

  return (
    <div className={cx('container')}>
      {isLoading && (
        <div className={cx('wrapper')}>
          <div className={cx('title', 'loading')}>Loading</div>
          <div className={cx('desc')}>Searching for video channels.</div>
        </div>
      )}
      {!isLoading && (
        <>
          {videoUrl === null && (
            <div className={cx('wrapper')}>
              <div className={cx('title')}>Not Streaming</div>
              <div className={cx('desc')}>No active video stream.</div>
            </div>
          )}
          {videoUrl && <ViewFinder url={videoUrl} />}
        </>
      )}
    </div>
  );
};

export default Window;
